export default __webpack_public_path__ + "static/156-750bf32bb9df89bb7e6957b05da01687.jpg";